module.exports = __webpack_public_path__ + "static/stalia-icon-1bab679a1b9c49337aa7881080524372.png";